import { computed } from 'vue'
import type { CommonContextStore } from 'src/types/context'
import useContextStore from 'src/store/useContextStore'
import formatPhone from 'src/functions/formatPhone'
import getLpuPhone from 'src/utils/getLpuPhone'
import type { Lpu } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'

/**
 * Публичный номер клиники для шапки прайса и мобильной панели звонка.
 */
export default function usePriceAppointmentPhone(lpu: Lpu) {
  const { context }: CommonContextStore = useContextStore()
  const rawPhone = computed(() => getLpuPhone({
    lpu,
    lpuAddress: lpu.addr?.[0],
  }) || '')
  const appointmentPhone = computed(() => (
    rawPhone.value
      ? formatPhone({
        phone: rawPhone.value,
        country: context.request.country,
      })
      : ''
  ))
  const appointmentPhoneHref = computed(() => (
    rawPhone.value
      ? `tel:${formatPhone({
        phone: rawPhone.value,
        country: context.request.country,
        isRaw: true,
      })}`
      : ''
  ))

  return {
    appointmentPhone,
    appointmentPhoneHref,
  }
}
